import Raven from 'raven-js';
import debugLogger from './debugLogger';

export default function() {
  debugLogger.log('use raven is: ', process.env.REACT_APP_USE_RAVEN === 'true');
  debugLogger.log(
    'public raven dsn url is: ',
    process.env.REACT_APP_PUBLIC_RAVEN_DSN_URL || 'undefined'
  );
  debugLogger.log(
    'sentry release name is: ',
    process.env.REACT_APP_SENTRY_RELEASE_NAME || 'undefined'
  );
  if (process.env.REACT_APP_USE_RAVEN === 'true') {
    debugLogger.log('Enabling Raven');
    Raven.config(process.env.REACT_APP_PUBLIC_RAVEN_DSN_URL, {
      release: process.env.REACT_APP_SENTRY_RELEASE_NAME,
      autoBreadcrumbs: {
        xhr: false, // XMLHttpRequest
        console: false, // console logging
        dom: false, // DOM interactions, i.e. clicks/typing
        location: false, // url changes, including pushState/popState
        sentry: false, // sentry events
      },
    }).install();
    Raven.setExtraContext({ language: 'javascript' }); // Just so we can filter by this in Sentry to distinguish from Ruby errors
    window.addEventListener('unhandledrejection', event => {
      // NB: Reason can be any rejected value, including null, undefined, objects, or errors,
      // but usually it should be an error.
      if (!event.detail.reason || !event.detail.reason.handled) {
        Raven.captureException(event.detail.reason);
      }
    });
  }
}
